import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      const detail = e.response?.data?.detail;
      setErr(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F4F5] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="block mb-8 font-mono text-xs uppercase tracking-[0.2em] text-[#091526]/60 hover:text-[#1E5BB8]">
          ← Back to site
        </Link>
        <div className="border-2 border-[#091526] bg-white p-8 md:p-10 hard-shadow">
          <div className="flex items-center gap-3 mb-8">
            <img src="/images/logo.png" alt="logo" className="h-12 w-12 border-2 border-[#091526] bg-white object-contain" />
            <div>
              <div className="font-display text-2xl">ADMIN</div>
              <div className="font-mono text-xs uppercase tracking-[0.2em] text-[#091526]/60">Pile Glide Pro</div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="block font-mono text-xs uppercase tracking-[0.2em] font-bold mb-2">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="admin-login-email"
                className="w-full bg-white border-2 border-[#091526] px-4 py-3 font-mono text-sm focus:outline-none focus:border-[#1E5BB8]"
              />
            </div>
            <div>
              <label className="block font-mono text-xs uppercase tracking-[0.2em] font-bold mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="admin-login-password"
                className="w-full bg-white border-2 border-[#091526] px-4 py-3 font-mono text-sm focus:outline-none focus:border-[#1E5BB8]"
              />
            </div>
            {err && (
              <div data-testid="admin-login-error" className="border-2 border-red-600 bg-red-50 text-red-700 px-4 py-3 text-sm">
                {err}
              </div>
            )}
            <button
              type="submit"
              disabled={busy}
              data-testid="admin-login-submit"
              className="w-full bg-[#1E5BB8] text-[#091526] font-bold uppercase text-sm tracking-[0.2em] px-6 py-4 border-2 border-[#091526] disabled:opacity-50"
            >
              {busy ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
